module.exports = "mutation DeleteApplication($applicationId:ID!){deleteApplication(applicationId:$applicationId){success}}"